module.exports = __webpack_public_path__ + "img/38.e1295971.jpg";